import styled from "styled-components"

const CountdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const CountdownNumber = styled.div`
  font-size: 48px;
  font-weight: bold;
  text-align: center;
  line-height: 1;
  padding-right: 30px;
`

type CountdownDisplayProps = {
  seconds: number
  label: string
  "data-testid"?: string
}

const CountdownDisplay = ({
  seconds,
  label,
  "data-testid": dataTestId,
}: CountdownDisplayProps) => (
  <CountdownContainer data-testid={dataTestId}>
    <div>{label}</div>
    <CountdownNumber>{seconds}</CountdownNumber>
  </CountdownContainer>
)

export default CountdownDisplay
